import React from 'react'
import { Link } from 'gatsby'
import { StHeader, StLogo } from './style.css'
import { Latercera } from 'copesa-logos'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Share from '../Sharer'

import iconlt from '../../images/icon-lt.png'

const Header = ({ titleTitle, sponsorLogo, handleToggleMenu, activeMenu }) => {
  return (
    <StHeader>
      <div className="slot-1">
        <StLogo className="logo-latercera">
          <Link to="/">
            <Latercera />
          </Link>
        </StLogo>
        <a className="btn-suscribete" href="https://especiales.latercera.com/suscripcion/?utm_medium=especialeslt&utm_source=palestina&utm_content=header&" target="_blank" rel="noopener noreferrer">Suscríbete</a>
      </div>
      <div className="slot-2">
        <Share
          socialConfig={{
            twitterHandle: 'latercera',
            config: {
              url: `https://especiales.latercera.com/palestina/`,
              title: `Palestina, ¿La hora de la paz? - La Tercera`,
            }
          }}
        />
        <div className="btn-menu" onClick={() => handleToggleMenu()}>
          {
            activeMenu ? (
              <FontAwesomeIcon className="icon" icon={['fas', 'times']} />
            ) : (
              <FontAwesomeIcon className="icon" icon={['fas', 'bars']} />
            )
          }
        </div>
      </div>
    </StHeader>
  )
}

export default Header